// Ken customizer modal
const dict = {
  uk: {
    customizer: {
      title: 'Створи свого Кена',
      close: 'Закрити',
      currencyUah: 'грн',
      soon: '(скоро)',
      noOption: 'Без',
      emptyCategory: 'Ще немає варіантів у цій категорії — з\'являться скоро',
      loading: 'Завантаження…',
      task: 'Завдання',
      free: 'Безкоштовно',
      taskHint: 'Деякі скіни відкриваються після виконання завдань — навчайся, читай і відкривай нові вигляди.',
      cancel: 'Скасувати',
      save: 'Готово',
      saving: 'Зберігаємо…',
      unlockErrorGeneric: 'Не вдалось розблокувати',
      unlockErrorNetwork: 'Помилка мережі',
      unlock: 'Відкрити',
      tryOnHint: 'Це лише примірка — відкрий скін, щоб зберегти його',
    },
  },
  en: {
    customizer: {
      title: 'Design your Ken',
      close: 'Close',
      currencyUah: 'UAH',
      soon: '(soon)',
      noOption: 'None',
      emptyCategory: 'No options in this category yet — coming soon',
      loading: 'Loading…',
      task: 'Task',
      free: 'Free',
      taskHint: 'Some skins unlock after you complete tasks — study, read, and reveal new looks.',
      cancel: 'Cancel',
      save: 'Done',
      saving: 'Saving…',
      unlockErrorGeneric: 'Failed to unlock',
      unlockErrorNetwork: 'Network error',
      unlock: 'Unlock',
      tryOnHint: 'Just trying it on — unlock this skin to keep it',
    },
  },
};

export default dict;
